import { useEffect, useState } from "react"
import { useParams } from "react-router-dom"
import { ProductoI } from "../models/productos"
import { getProducto } from "../services/productos/productos"
import { isNewRegister } from "../utils/strings"
import { DescargableI } from "../models/descargables"
import { getDescargable, getDescargableSKu } from "../services/descargable"

const useFetchProduct = () => {

    const { id } = useParams()
    const [producto, setProducto] = useState<ProductoI>()
    const [descargable, setDescargable] = useState<DescargableI>()

    useEffect(() => {

        if (!id) return
        if (isNewRegister(id)) return

        const fetchProducto = async () => {

            const productoDB = await getProducto(id) as any

            const imagenes = productoDB.imagenes.map((i: any) => {
                return {
                    ...i,
                    archivoUrl: i.archivo,
                    archivo: null,
                }
            }).sort((a: any, b: any) => a.orden - b.orden)
            const imagenesPequenas = productoDB.imagenes_pequenas.map((i: any) => {
                return {
                    ...i,
                    archivoUrl: i.archivo,
                    archivo: null,
                }
            }).sort((a: any, b: any) => a.orden - b.orden)

            const data = {
                ...productoDB,
                imagen_complementariaUrl: productoDB.imagen_complementaria,
                imagen_complementaria: null,
                imagen_principalUrl: productoDB.imagen_principal,
                imagen_principal: null,
                infografiaUrl: productoDB.infografia,
                infografia: null,
                productos_imagenes: imagenes,
                productos_imagenes_pequenas: imagenesPequenas,
            }

            setProducto(data)
            fetchDescargableSku(productoDB?.sku)
        }

        fetchProducto()

    }, [id])

    const fetchDescargableSku = async (sku?: string) => {
        
        if(!sku) return

        const descargableDB = await getDescargableSKu(sku) as any

        if(!descargableDB) return
        
        setDescargable(descargableDB)

    }

    return {
        producto,
        descargable,
        setProducto,
    }

}

export default useFetchProduct